export const mapRatingImagesToFrontend = (images = []) => {
    return images.map(image => {
        // Extract file type from imageName extension
        const fileNameLower = (image.imageName || "").toLowerCase();
        let fileType = "image/jpeg"; // default

        if (fileNameLower.includes(".mp4")) {
            fileType = "video/mp4";
        } else if (fileNameLower.includes(".webm")) {
            fileType = "video/webm";
        } else if (fileNameLower.includes(".png")) {
            fileType = "image/png";
        } else if (fileNameLower.includes(".gif")) {
            fileType = "image/gif";
        } else if (fileNameLower.includes(".jpg") || fileNameLower.includes(".jpeg")) {
            fileType = "image/jpeg";
        }

        return {
            id: image.imageId,
            name: image.imageName,
            url: image.imageUrl,
            type: fileType
        };
    });
};
